module.exports = __webpack_public_path__ + "img/create-filter.5649c947.png";